import axios from 'axios';
import { setOnScreenEls, checkOnScreenEls } from '../common/on-screen';

import '../../sass/template-parts/category-posts-list.scss';

(() => {
    const $categoryPostsLists = document.querySelectorAll('.category-posts-list');

    if (!$categoryPostsLists) return;

    $categoryPostsLists.forEach($categoryPostsList => {
        const abortController = new AbortController();

        const $resultsList = $categoryPostsList.querySelector('.category-posts-list-results__list');
        const $resultsListInner = $categoryPostsList.querySelector('.category-posts-list-results__list-inner');
        const $noResults = $categoryPostsList.querySelector('.category-posts-list-results__no-results');
        const $loadMore = $categoryPostsList.querySelector('.category-posts-list-results__load-more');

        const $loadMoreNonce = $loadMore?.querySelector('input[name="delancey_theme_load_more_news_wpnonce"]');
        const $loadMoreCategory = $loadMore?.querySelector('input[name="category"]');
        const $loadMoreKeyword = $loadMore?.querySelector('input[name="keyword"]');
        const $loadMorePage = $loadMore?.querySelector('input[name="category_page"]');
        const $loadMorePostsPerPage = $loadMore?.querySelector('input[name="posts_per_page"]');

        const setNewsItems = (data, args) => {
            const {
                category = null,
            } = args;

            // If results returned show results list and hide 'no results' message
            if (data?.html) {
                if (data?.page === 1) {
                    $resultsListInner.innerHTML = data.html;
                } else {
                    $resultsListInner.insertAdjacentHTML('beforeend', data.html);
                }

                $resultsList.classList.add('category-posts-list-results__list--show');
                $noResults.classList.remove('category-posts-list-results__no-results--show');

                setOnScreenEls();
                checkOnScreenEls();
            }

            // If no results returned show 'no results' message and hide results
            if (!data?.html) {
                if (data?.page === 1) {
                    $resultsListInner.innerHTML = '';
                }

                $resultsList.classList.remove('category-posts-list-results__list--show');
                $noResults.classList.add('category-posts-list-results__no-results--show');
            }

            // Show/hide load more button
            if (data?.post_count >= data?.found_posts || !data?.html) {
                $loadMore.classList.remove('category-posts-list-results__load-more--show');
            } else {
                $loadMore.classList.add('category-posts-list-results__load-more--show');
            }

            // Set load more args
            if ($loadMoreKeyword) $loadMoreKeyword.value = keyword ?? '';
            if ($loadMorePage) $loadMorePage.value = data?.page && !isNaN(data?.page) ? parseInt(data.page) + 1 : 1;

            // Build new URL
            const url = new URL(window.location.href);
            const searchParams = url.searchParams;

            // Add category to URL
            if (category) {
                searchParams.set('category', category);
            } else {
                searchParams.delete('category');
            }

            // Add block_anchor to URL
            if ($categoryPostsList?.id) {
                searchParams.set('block_anchor', $categoryPostsList.id);
            } else {
                searchParams.delete('block_anchor');
            }

            // Add page number to URL
            searchParams.set('category_page', data?.page ?? 1);

            // Update URL
            window.history.replaceState('', '', url.toString());

            // Set back_url for portfolio links
            const $portfolioCardLinks = $resultsListInner.querySelectorAll('.news-card__link, .news-card-alt__link');

            if ($portfolioCardLinks) {
                $portfolioCardLinks.forEach($portfolioCardLink => {
                    if (!$portfolioCardLink?.href) return;

                    const cardUrl = new URL($portfolioCardLink.href);
                    const cardUrlSearchParams = cardUrl.searchParams;

                    cardUrlSearchParams.set('back_url', window.location.href);

                    $portfolioCardLink.href = cardUrl.toString();
                });
            }
        };

        const loadMore = () => {
            $loadMore.classList.add('category-posts-list-results__load-more--loading');

            axios.get(GLOBALS.AJAX_URL, {
                signal: abortController.signal,
                params: {
                    action: 'delancey_theme_filter_news',
                    nonce: $loadMoreNonce?.value ?? null,
                    category: $loadMoreCategory?.value ?? null,
                    page: $loadMorePage?.value ?? null,
                    posts_per_page: $loadMorePostsPerPage?.value ?? null,
                }
            }).then(response => {
                setNewsItems(
                    response?.data?.data,
                    {
                        category: $loadMoreCategory?.value
                    }
                );
            }).catch(error => {
                console.log(error);

                //$loadMore.submit();
            }).finally(() => {
                $loadMore.classList.remove('category-posts-list-results__load-more--loading');
            });
        };

        const initLoadMore = () => {
            if (!$loadMore) return;

            $loadMore.addEventListener('submit', e => {
                e.preventDefault();

                loadMore();
            });
        };

        initLoadMore();
    });
})();
